import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchHomeData } from "./homeAPI";
export interface HomeState {
  homeData: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: HomeState = {
  homeData: [],
  status: "idle",
};

export const GetHomeData = createAsyncThunk("home/fetchHomeData", async (id:any) => {
  const response = await fetchHomeData(id);
  return response;
});

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetHomeData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetHomeData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetHomeData.fulfilled, (state, action) => {
        state.status = "success";
        state.homeData = [...state.homeData, action.payload];
      });
  },
});

export const {} = homeSlice.actions;

export const selectHomeData = (state: RootState) => {
  return state.home.homeData[0];
};

export default homeSlice.reducer;
